import { ValidationInstance } from './validation-instance';

export class Validation {
    constructor() {
        this._validators = {};
    }

    registerValidator(name, validator) {
        this._validators[name] = validator;
    }

    init(form, options) {
        return new ValidationInstance(form, this, options);
    }

    get validators() {
        return this._validators;
    }
}